import React, { useState, useEffect, useContext } from "react";
import styles from "./ChatHeader.module.css";
import { AssistantContext } from "../../context/AssistantContext";
import { FiSettings } from "react-icons/fi";
import Settings from "../settings/Settings";
import ChatLogo from "../../assets/chat.svg";

const ChatHeader = () => {
  const { settings } = useContext(AssistantContext);
  const [isSettingsOpen, setSettingsOpen] = useState(false);

  useEffect(() => {
    const currentTheme = localStorage.getItem("theme") || settings.theme;
    document.querySelector("html").setAttribute("data-theme", currentTheme);
  }, [settings.theme]);

  const openSettings = () => {
    setSettingsOpen(true);
  };
  
  const handleCloseSettings = () => {
    setSettingsOpen(false);
  };

  return (
    <>
      <div className={styles['chat-header']}>
        <div className={styles['new-chat-logo']}>
          <a
            href='/'
            title='New Chat'
            onClick={(e) => {
              e.preventDefault();
              localStorage.setItem("messages", JSON.stringify([]));
              window.location.href = "/";
            }}
          >
            <img src={ChatLogo} alt='New Chat' />
          </a>
        </div>
        <div style={{ flex: 1 }} />
        <button
          onClick={openSettings}
          className={styles['settings-button']}
          aria-label='Open Settings'
        >
          <FiSettings />
        </button>
      </div>
      <Settings isOpen={isSettingsOpen} onClose={handleCloseSettings} />
    </>
  );
};

export default ChatHeader;
